import { Box } from "@mui/material";
import { useState } from "react";
import { TextInput } from "../styles";
import { DropdownPopover } from "./DropdownPopover";

/**
 * Dropdown Input Component
 * @param {Object} props
 * @param {String} id Dropdown Input id
 * @param {Boolean} open
 * @param {String} label Dropdown Input label
 * @param {String} value Dropdown Input value
 * @param {Object} inputProps Dropdown Input Component props
 * @param {Function} onClick Function to execute on input click
 * @param {Element} children Dropdown Popover children
 * @returns JSX.Element
 */
export const InputDropdown = ({ id, open, label, value, inputProps, onClick, children, PaperProps, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [maxWidth, setMaxWidth] = useState(0);

  const handleClick = (event) => {
    setAnchorEl(event.target);
    setMaxWidth(event.target.clientWidth - 50);
    onClick();
  };

  const handleClose = () => {
    setAnchorEl(null);
    onClick();
  };

  return (
    <>
      {/* Input Part */}
      <Box onClick={handleClick}>
        <TextInput
          id={`${id}-input`}
          label={label}
          value={value}
          type="text"
          version="new"
          size="small"
          autoComplete="off"
          fullWidth
          readOnly
          {...inputProps}
        />
      </Box>

      {/* Dropdown Part */}
      <DropdownPopover
        id={`${id}-popover`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          ...PaperProps,
          sx: { width: maxWidth },
        }}
        {...props}
      >
        {children}
      </DropdownPopover>
    </>
  );
};
